import React, { memo, useRef } from "react";
import _ from "lodash";
import { useReduxState } from "SubjectStandardsV2/hooks";
import { getCurrentAcademicSetupTypeFromState } from "modules/CommonSelectors";
import {
  COURSE_BASED_GRADING,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
} from "Constants/stringConstants";
import {
  CourseBasedGradingWrapper,
  SubjectBasedGradingWrapper,
} from "./components";
import { FilterProvider } from "./providers/FilterProvider";
import { DSProvider } from "@toddle-edu/ds-web";
import useTreeManager from "AppComponents/DatasetTaggingBody/hooks/useTreeManager";
import { getIsLearningCoursesEnabledForUnit } from "UnitPlans/modules/UnitViewModeUtils";

const AcademicSetupTypeWrapper = props => {
  const { academicSetupType, isOldSubjectBasedGrading } = useReduxState(
    getCurrentAcademicSetupTypeFromState
  );

  const isLearningCourseEnabled = getIsLearningCoursesEnabledForUnit();
  //this handles the case when LearningCourse is enabled in next AY,
  //but in the current AY LC is not available but the academicSetupType is CBG,
  // remove when academicSetupType goes at AY level.
  if (isLearningCourseEnabled && academicSetupType === COURSE_BASED_GRADING) {
    return <CourseBasedGradingWrapper {...props} />;
  } else
    return (
      <SubjectBasedGradingWrapper
        {...props}
        isOldSubjectBasedGrading={isOldSubjectBasedGrading}
      />
    );
};

const PlannerElementDataSetModalV2 = props => {
  const { initialFilters, resolvedValue, plannerElementType } = props;
  const isPypStandards =
    plannerElementType === ELEMENT_TYPE_PYP_LEARNING_STANDARD;
  const getKey = isPypStandards ? "benchmarks" : "nodes";

  const treeMapRef = useRef({});

  // Initialize tree manager hook
  const { updateTree, getAncestorTree } = useTreeManager({
    initialNodes: _.get(resolvedValue, getKey, []),
    isPypStandards,
    treeMapRef,
  });

  return (
    <DSProvider dsVersion="2.0">
      <FilterProvider initialFilters={initialFilters}>
        <AcademicSetupTypeWrapper
          {...props}
          updateTree={updateTree}
          getAncestorTree={getAncestorTree}
          treeMapRef={treeMapRef}
        />
      </FilterProvider>
    </DSProvider>
  );
};

export default memo(PlannerElementDataSetModalV2);
